"use strict";

var _interopRequireDefault = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime@7.17.8@@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime-corejs2@7.17.8@@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

require("core-js/modules/es6.function.name");

var _wxAuthorize = _interopRequireDefault(require("@/mixins/wx-authorize"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _member = require("@/api/member");

var _member2 = require("../../../api/member");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// openid 与公众号绑定：切回默认公众号后，资金周转期备用号下的旧 openid 已失效，
// 这里用独立 key 存放，避免读到旧值导致创建试用小程序时 openid 不匹配。
// 切换公众号时需同步改此 key（如 'openid_baseinfo'），步骤见后端 config/wechat.php 的 baseinfo 段注释
var OPENID_KEY = 'openid_default';
var _default = {
  name: 'FastcreatebetaMiniprogram',
  mixins: [_wxAuthorize.default],
  components: {},
  props: {},
  data: function data() {
    return {
      openid: '',
      name: '',
      dialogVisable: false,
      shop: ''
    };
  },
  computed: {
    disabled: function disabled() {
      return this.name ? false : true;
    }
  },
  watch: {},
  created: function created() {
    // 清掉备用号时期遗留的旧 openid，避免跨公众号串用
    if (_jsCookie.default.get('openid')) _jsCookie.default.remove('openid');

    if (_jsCookie.default.get(OPENID_KEY)) {
      console.log('本地缓存获取到了openid:' + _jsCookie.default.get(OPENID_KEY));
      this.openid = _jsCookie.default.get(OPENID_KEY);
      this.fetchData();
    } else if (this.$route.query.openid) {
      console.log('url参数获取到了openid:' + this.$route.query.openid);
      this.openid = this.$route.query.openid;

      _jsCookie.default.set(OPENID_KEY, this.$route.query.openid);

      this.fetchData();
    } else {
      console.log('没有openid 需要登录');
      this.wxLogin(this);
    }
  },
  methods: {
    fetchData: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _member.fastcreatebetaScan)({
                  openid: this.openid,
                  id: this.$route.query.id,
                  identityToken: this.$route.query.identityToken
                });

              case 2:
                res = _context.sent;
                if (res.code === 0) this.shop = res.data;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchData() {
        return _fetchData.apply(this, arguments);
      }

      return fetchData;
    }(),
    create: function create() {
      console.log('create...');
      this.dialogVisable = true;
    },
    save: function () {
      var _save = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('save');
                console.log({
                  name: this.name,
                  openid: this.openid
                });
                this.dialogVisable = false;
                _context2.next = 5;
                return (0, _member2.fastcreatebeta)({
                  name: this.name,
                  openid: this.openid,
                  id: this.$route.query.id,
                  identityToken: this.$route.query.identityToken
                });

              case 5:
                res = _context2.sent;

                if (res.data.authorize_url) {
                  window.location.href = res.data.authorize_url;
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function save() {
        return _save.apply(this, arguments);
      }

      return save;
    }()
  }
};
exports.default = _default;